import React from 'react';
import { SitecoreImageField } from 'components/sitecore-fields';

class MastercardPromoPanelTiles extends React.Component {
    render() {
        const { tiles, onClick } = this.props;
        return (
            <div className="mastercard-promo-panel__grid">
                { tiles.map((tile) => {
                    return (
                        <div key={tile.id} className="mastercard-promo-panel__grid--item">
                            <div className="mastercard-promo-panel__grid--box" key={tile.id}>
                                {
                                    (tile.link !== null && tile.link !== undefined) &&
                                    <a className="mastercard-promo-panel__grid--link" onClick={() => onClick(tile)}>
                                        <div className="mastercard-promo-panel__grid--bg">
                                            <SitecoreImageField img={tile.image} className="mastercard-promo-panel__grid--img"></SitecoreImageField>
                                        </div>
                                        <div className="mastercard-promo-panel__grid--content">
                                            <h4 className="mastercard-promo-panel__grid--title">{tile.title}</h4>
                                        </div>
                                    </a>
                                }
                                {
                                    (tile.link === null || tile.link === undefined) &&
                                    <div>
                                        <div className="mastercard-promo-panel__grid--bg">
                                            <SitecoreImageField img={tile.image} className="mastercard-promo-panel__grid--img"></SitecoreImageField>
                                        </div>
                                        <div className="mastercard-promo-panel__grid--content">
                                            <h4 className="mastercard-promo-panel__grid--title">{tile.title}</h4>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default MastercardPromoPanelTiles;
